/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CardMastercardTransactionStatuses } from '../constants';

const TransactionItemLayout = ({ tx, onDetailsClick }) => {
  const { t: translate } = useTranslation();

  const icon = (
    <div className="position-relative">
      <i
        style={{ width: '1.5rem', height: '1.5rem' }}
        className={`border rounded-max p-3 border-disabled icon ${tx.icon} text-f4 me-3 d-flex justify-content-center align-items-center text-shadow`}
      />
      {tx.transactionStatus &&
        tx.transactionStatus === CardMastercardTransactionStatuses.DECLINED && (
          <i
            style={{ width: '1rem', height: '1rem', right: '13px', bottom: '-3px' }}
            className="position-absolute border bg-danger border-1 text-white border-grey-lighter rounded-max text-f7 p-1 icon icon-close-other justify-content-center align-items-center text-shadow d-flex"
          />
        )}
    </div>
  );
  const merchant = (
    <div className="d-flex flex-column me-auto">
      <p className="text-f5">{tx?.merchant}</p>
      <p className="text-shadow text-f6">{tx.merchantType}</p>
    </div>
  );

  const renderAmount = () => {
    let color = '';
    if (tx.transactionStatus === CardMastercardTransactionStatuses.DECLINED) {
      color = 'text-danger';
    } else if (tx?.isPrimary) {
      color = 'text-success';
    }
    return (
      <p className={`text-end text-md-center ${color}`}>
        <b>{`${tx?.displayAmount}`}</b>
      </p>
    );
  };
  const details = (
    <button
      type="button"
      className="btn text-btn-item text-primary text-f6 py-0 px-0 border-0"
      onClick={() => onDetailsClick(tx)}>
      <b>{translate('details_button_title')}</b>
    </button>
  );

  return (
    <>
      {/* mobile */}
      <div
        className="row d-md-none bg-lighter rounded-extra px-4 px-1 mx-0 my-2"
        onClick={() => onDetailsClick(tx)}
        onKeyDown={null}
        tabIndex={-1}
        role="button">
        <div className="col-md-6 col-sm-6 col-8 flex-row-center me-auto my-auto ps-0">
          {icon}
          {merchant}
        </div>
        <div className="col-md-3 col-sm-3 col-4 me-auto my-auto">{renderAmount()}</div>
        <div className="col-md-3 col-sm-3 col-4 d-md-block d-sm-block d-none text-end my-auto pe-0">
          {details}
        </div>
      </div>

      {/* browser */}
      <div className="d-none d-md-flex row bg-lighter rounded-extra px-4 px-1 mx-0 my-3 py-3">
        <div className="col-md-6 col-sm-6 col-8 flex-row-center me-auto my-auto ps-0">
          {icon}
          {merchant}
        </div>
        <div className="col-md-3 col-sm-3 col-4 me-auto my-auto">{renderAmount()}</div>
        <div className="col-md-3 col-sm-3 col-4 d-md-block d-sm-block d-none text-end my-auto pe-0">
          {details}
        </div>
      </div>
    </>
  );
};

export default TransactionItemLayout;

TransactionItemLayout.propTypes = {
  tx: PropTypes.object.isRequired,
  onDetailsClick: PropTypes.func.isRequired,
};
